import * as React from 'react';
import { AspectRatio } from 'react-aspect-ratio';

import { Box, Typography, styled } from '@mui/material';

import LazyAvatar, { LazyAvatarProps } from '../../../components/Avatar/LazyAvatar/LazyAvatar';
import PlayIcon from '../../../components/PlayIcon/PlayIcon';
import { VenueReservationContentItemV2 } from '../../../graphql/API';
import Icons from '../../../themes/icons';

export const AvatarContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  position: 'absolute',
  bottom: 20,
  left: 15,
});

export const RequirementContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  position: 'absolute',
  top: 12,
  left: 12,
  zIndex: 99,
});

const AvatarBody: React.FC<LazyAvatarProps> = (props) => (
  <Box
    sx={{
      borderRadius: '50%',
      border: '1px solid #FFFFFF',
      mr: 1.5,
    }}
  >
    <LazyAvatar {...props} sx={{ width: '2rem', height: '2rem' }} />
  </Box>
);

type ContentProps = {
  onClick: React.MouseEventHandler;
  src: string;
  video?: string;
  userAvatar: string;
  name: string;
  data?: VenueReservationContentItemV2;
};

const Content: React.FC<ContentProps> = ({ onClick, src, userAvatar, name, video, data }) => {
  return (
    <Box sx={{ position: 'relative', cursor: 'pointer' }} onClick={onClick}>
      {data?.ispost && (
        <RequirementContainer>
          {data?.postOnInstagramStories || data?.postOnInstagramStories3x ? (
            <Icons.Content1StoryIcon />
          ) : data?.postOnInstagramFeed ? (
            <Icons.ContentFeedIcon />
          ) : data?.postOnInstagramReels ? (
            <Icons.ContentReelIcon />
          ) : data?.postOnTikTokVideo ? (
            <Box
              display={'flex'}
              alignItems={'center'}
              justifyContent={'center'}
              sx={{
                width: '34px',
                height: '34px',
                background: 'rgba(255, 255, 255, 0.90)',
                borderRadius: '50%',
              }}
            >
              <Icons.TiktokIcon />
            </Box>
          ) : null}
        </RequirementContainer>
      )}
      <AspectRatio ratio='0.8'>
        <Box
          component='img'
          src={src}
          alt=''
          sx={{ borderRadius: '10px', objectFit: 'cover', width: '100%', height: '100%' }}
        />
        {video && <PlayIcon />}
      </AspectRatio>
      <AvatarContainer>
        <AvatarBody variant='circular' src={userAvatar} />
        <Typography color='white' fontWeight={500} fontSize={'15px'} sx={{ fontFamily: 'Poppins' }}>
          {name}
        </Typography>
      </AvatarContainer>
    </Box>
  );
};

export default Content;
